module.exports = __webpack_public_path__ + "img/predictive.2dd0f40d.svg";